'use client'

import { useMemo } from 'react'

import FileIcon from '@/icons/FileIcon'
import { cn } from '@/lib/utils'

type AttachFileItemProps = {
  filename: string
  className?: string
  isRemoveBtn?: boolean
  isClickable?: boolean
  onRemoveAction?: () => void
  onPreviewAction?: () => void
}

export default function AttachFileItem({
  filename,
  className = '',
  isRemoveBtn = true,
  isClickable = false,
  onRemoveAction = () => {},
  onPreviewAction = () => {},
}: AttachFileItemProps) {
  const fileExt = useMemo(
    () => (filename.includes('.') ? filename.split('.').toReversed()[0] : ''),
    [filename]
  )

  return (
    <div
      className={cn(
        'relative flex max-w-[250px] gap-x-4 rounded-2xl border border-neutral-200 bg-white p-2 shadow-sm',
        { 'cursor-pointer hover:opacity-80': isClickable },
        className
      )}
      onClick={onPreviewAction}
    >
      <div className="flex items-center gap-x-2 p-1">
        <span
          className={'flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-neutral-100'}
        >
          <FileIcon />
        </span>
        <div className="text-sm">
          <p className={cn('line-clamp-1 font-medium', 'text-neutral-800')}>{filename}</p>
          <p className={cn('uppercase', 'text-neutral-500')}>{fileExt}</p>
        </div>
      </div>
      {isRemoveBtn && (
        <div
          className={
            'flex h-4 w-4 shrink-0 rotate-45 cursor-pointer items-center justify-center rounded-full border-2 border-neutral-400 hover:bg-neutral-100'
          }
          onClick={onRemoveAction}
        >
          <span className={'-mt-0.5 select-none font-medium text-neutral-600'}>+</span>
        </div>
      )}
    </div>
  )
}
